<template lang="html">
  <header class="header-cabinet">
    <div class="container-fluid">
      <div class="row">
        <div class="header-cabinet__logo-wrapper col-12 col-md-6 col-lg-5">
          <a href="/">
            <picture class="header-cabinet__logo">
              <img
                src="~@/assets/img/header/logo.svg"
                srcset="~@/assets/img/header/logo.svg"
                alt="Унистрой Маркет"
                width="227"
                height="40"
              >
            </picture>
          </a>
        </div>

        <nav class="header-cabinet__nav-wrapper col-12 col-md-6 col-lg-7">
          <!--div class="header-cabinet__nav-item">
            <form class="header-cabinet__search" action="https://echo.htmlacademy.ru" method="post">
              <input type="search" placeholder="Ключевое слово для поиска" class="header-cabinet__search-input" value=""
                     id="header-cabinet__search-input" name="search-header">
              <span class="header-cabinet__search-icon"></span>
            </form>
          </div-->
          <DateTime />
        </nav>
      </div>
    </div>
  </header>
</template>

<script lang="js">
import { defineComponent } from 'vue';
import DateTime from '@/components/elements/DateTime.vue';

export default defineComponent({
  name: 'MainHeader',
  components: {
    DateTime,
  },
});
</script>

<style lang="scss" scoped>

</style>
